export const MEDIA_QUERY_CONFIG = {
    xxl: '(min-width: 1201px)',
    xl: '(min-width: 961px) and (max-width: 1200px)',
    lg: '(min-width: 769px) and (max-width: 960px)',
    md: '(min-width: 641px) and (max-width: 768px)',
    sm: '(min-width: 481px) and (max-width: 640px)',
    xs: '(min-width: 0px) and (max-width: 480px)'
};
